import { memo } from 'react';
import cn from 'classnames';
import guaranteeImage from '@public/_nextassets_/images/guarantee-badge-dark.svg';
import { Grid } from 'ht-styleguide';
import styles from '../plansPage.module.scss';

type PlansPageProps = {
  classes?: string;
  title?: string;
  text?: string;
};

const PlanGuaranteeBlock = ({ classes, title, text }: PlansPageProps) => {
  const subTitleStyles = cn('p1 n000', styles.subTitle);
  const titleStyles = cn('n000', styles.title);
  const containerStyles = cn(styles.guaranteeContainer, classes);

  return (
    <section className={containerStyles}>
      <Grid.Fluid>
        <Grid.Row>
          <Grid.Column sm={4} md={8} lgOffset={1} lg={10} classes={styles.gridWrapper}>
            <img src={guaranteeImage} className={styles.image} alt="hellotech guarantee" />
            <div className={styles.textContainer}>
              <h5 className={titleStyles}> {title} </h5>
              <p className={subTitleStyles}>{text}</p>
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid.Fluid>
    </section>
  );
};

export default memo(PlanGuaranteeBlock);

/*
Usage:

import PlanGuaranteeBlock from 'src/components/Sections/PlanGuaranteeBlock';

<PlanGuaranteeBlock />

--------------------------------------------------
classes: custom classes on the wrapper for the component - can be used to change background color.
title: any string title for customization.
text: any string copy for customization.

*/
